import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import DeploymentsPage from "@/pages/DeploymentsPage";
import AIChatPage from "@/pages/AIChatPage";
import EnvironmentsPage from "@/pages/EnvironmentsPage";
import PipelinesPage from "@/pages/PipelinesPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import ErrorDetectivePage from "@/pages/ErrorDetectivePage";
import CodeReviewPage from "@/pages/CodeReviewPage";
import TeamsPage from "@/pages/TeamsPage";
import WebhooksPage from "@/pages/WebhooksPage";
import ScheduledDeploymentsPage from "@/pages/ScheduledDeploymentsPage";
import AutoFixPage from "@/pages/AutoFixPage";
import "@/App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-dark-space flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-dark-space flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/deployments" element={<ProtectedRoute><DeploymentsPage /></ProtectedRoute>} />
          <Route path="/ai-chat" element={<ProtectedRoute><AIChatPage /></ProtectedRoute>} />
          <Route path="/environments" element={<ProtectedRoute><EnvironmentsPage /></ProtectedRoute>} />
          <Route path="/pipelines" element={<ProtectedRoute><PipelinesPage /></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
          <Route path="/error-detective" element={<ProtectedRoute><ErrorDetectivePage /></ProtectedRoute>} />
          <Route path="/code-review" element={<ProtectedRoute><CodeReviewPage /></ProtectedRoute>} />
          <Route path="/teams" element={<ProtectedRoute><TeamsPage /></ProtectedRoute>} />
          <Route path="/webhooks" element={<ProtectedRoute><WebhooksPage /></ProtectedRoute>} />
          <Route path="/scheduled" element={<ProtectedRoute><ScheduledDeploymentsPage /></ProtectedRoute>} />
          <Route path="/auto-fix" element={<ProtectedRoute><AutoFixPage /></ProtectedRoute>} />
        </Routes>
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: '#151929',
              border: '1px solid #1F294F',
              color: '#E0E0E0',
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
